<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['Approved', 'Pending', 'Rejected']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                        color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUNDRY ITEMS">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'sundry-item-sheet'" :filters="filters" />
              <vs-button v-can="'create-edit-sundry-suppliers'" @click="onClickCreateSundryItem" class="mr-4" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              id="sundry-item-list-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th  sort-key="sundry_item_code">ITEM CODE</vs-th>
                <vs-th width="20%" sort-key="sundry_product_code">PRODUCT CODE</vs-th>
                <vs-th width="20%">PRODUCT NAME</vs-th>
                <vs-th>SUPPLIER NAME</vs-th>
                <vs-th width="15%">COUNTRY</vs-th>
                <vs-th >STATUS</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].sundry_item_code">
                    {{ data[indextr].sundry_item_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_code">
                    {{ data[indextr].sundry_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_name">
                    {{ data[indextr].sundry_product_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier_name">
                    <HyperLink :id="data[indextr].supplier_id" type="supplier">{{ data[indextr].supplier_name}}</HyperLink>
                  </vs-td>


                  <vs-td :data="data[indextr].country_manufacture">
                    {{ data[indextr].country_manufacture}}
                  </vs-td>

                  <vs-td>
                    <vs-chip transparent :color="sundryItemStatusColorFactory(data[indextr].status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" class="ml-2" text="View/Update" position="left">
                        <vs-button @click="onClickUpdateSundryItem(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" v-if="[1, 3, 4].includes(data[indextr].status.id)" class="ml-2" text="Approve" position="left">
                        <vs-button @click="openStatusChangeConfirm(data[indextr].id, 'approve')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" v-if="[1, 2, 4].includes(data[indextr].status.id)" class="ml-2" text="Reject" position="left">
                        <vs-button @click="openStatusChangeConfirm(data[indextr].id, 'reject')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-sundry-suppliers'" v-if="[1, 2, 3].includes(data[indextr].status.id)" class="ml-2" text="Not In Use" position="left">
                        <vs-button @click="openStatusChangeConfirm(data[indextr].id, 'not_in_use')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-circle"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <create-sundry-supplier-pop-up ref="createSundrySupplierPopUp" />
    <create-sundry-item-pop-up ref="createSundryItemPopUp" />
    <update-sundry-item-pop-up ref="updateSundryItemPopUp"/>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SundrySuppliersRepository = RepositoryFactory.get('sundry')
  import CreateSundrySupplierPopUp from '@/components/popups/sundry-suppliers/CreateSundrySupplierPopUp'
  import CreateSundryItemPopUp from '@/components/popups/sundry-suppliers/CreateSundryItemPopUp'
  import UpdateSundryItemPopUp from '@/components/popups/sundry-suppliers/UpdateSundryItemPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "../../../../../constants/config";


  export default {
    name: 'AllUsersList',
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        id: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateSundrySupplierPopUp,
      CreateSundryItemPopUp,
      UpdateSundryItemPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.id = this.$route.params.id
      if (this.$route.query.open ) {
        await this.$refs.updateSundryItemPopUp.openPopup(this.$route.query.open)
      }
    },
    methods: {
      async refreshData () {
        this.fetchSundryItems()
      },
      async onClickSupplierView (id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/sundry/${id}`})
      },
      async fetchSundryItems() {
        await this.$vs.loading({
          container: '#sundry-item-list-table',
          scale: 0.45
        })
        try {
          if (!!this.id) {
            const {data} = await SundrySuppliersRepository.getListOfSundryItems(this.id, this.page, this.filterQuery, this.perPage, this.sort)
            this.items =  data.data
            this.meta = data.meta
          } else {
            const {data} = await SundrySuppliersRepository.getListOfSystemSundryItems(this.page, this.filterQuery, this.perPage, this.sort)
            this.items =  data.data
            this.meta = data.meta
          }
        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
      },

      async onClickUpdateSundryItem (id) {
        await this.$refs.updateSundryItemPopUp.openPopup(id)
      },
      async onClickCreateSundryItem () {
        await this.$refs.createSundryItemPopUp.openPopup(this.id)
      },

      openStatusChangeConfirm (id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: status === 'approve' ? 'success' : 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.changeSundryItemStatus,
          parameters: [id, status]
        })
      },
      async changeSundryItemStatus (params) {
        this.$vs.loading()
        try {
          await SundrySuppliersRepository.sundryItemStatusChange(params[0], params[1])
          this.showSuccessMessage('Sundry item status updated!')
          await this.fetchSundryItems()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      filterQueryUpdate (){
        this.fetchSundryItems()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundryItems()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundryItems()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      sundryItemStatusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
          case 4:
            return 'warning';
        }
      },
    },
    watch : {
      page(){
        this.fetchSundryItems()
      },
      perPage() {
        this.fetchSundryItems()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
